// import {
// 	Button,
// 	Card,
// 	CardContent,
// 	Modal,
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableRow,
// 	Typography,
// } from '@mui/material';
// import React, { useState } from 'react';
// import CloseIcon from '@mui/icons-material/Close';
// import { Box } from '@mui/system';
// import {
// 	StyledCrossIconButton,
// 	StyledTab,
// 	StyledTabs,
// } from '../../components/component/ThemeComponent';
// interface OrderItem {
// 	productId: string;
// 	quantity: number;
// 	price: number;
// 	subtotal: number;
// 	weight: number;
// 	name: string;
// 	category: string;
// }

// interface ShippingAddress {
// 	name: string;
// 	phone: string;
// 	address: string;
// 	city: string;
// 	state: string;
// 	country: string;
// 	postalCode: string;
// 	email: string;
// }

// interface Order {
// 	_id: string;
// 	orderId: string;
// 	orderStatus: string;
// 	paymentStatus: string;
// 	razorpayOrderId: string;
// 	shiprocketOrderId: string;
// 	shiprocketReferenceId: string;
// 	totalAmount: number;
// 	totalWeight: number;
// 	createdAt: string;
// 	updatedAt: string;
// 	userId: string;
// 	cancelReason: string | null;
// 	items: OrderItem[];
// 	shippingAddress: ShippingAddress;
// }
// const ReuseableTap = ({
// 	selectedOrder,
// 	handleClose,
// 	open,
// }: {
// 	selectedOrder: Order;
// 	handleClose: () => void;
// 	open: boolean;
// }) => {
// 	// const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
// 	const [tabValue, setTabValue] = useState<number>(0);
// 	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
// 		setTabValue(newValue);
// 	};
// 	return (
// 		<Modal
// 			open={open}
// 			onClose={handleClose}
// 			aria-labelledby="modal-modal-title"
// 			aria-describedby="modal-modal-description"
// 		>
// 			<Box
// 				sx={{
// 					position: 'absolute',
// 					top: '50%',
// 					left: '50%',
// 					transform: 'translate(-50%, -50%)',
// 					width: { xs: 300, sm: 400, md: '80%' },
// 					bgcolor: 'background.paper',
// 					border: '0px',
// 					boxShadow: 24,
// 					p: 4,
// 					borderRadius: '8px',
// 				}}
// 			>
// 				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
// 					<Typography
// 						id="modal-modal-title"
// 						variant="h6"
// 						component="h2"
// 						style={{ fontFamily: 'Poppins' }}
// 					>
// 						Order Details
// 					</Typography>
// 					<StyledCrossIconButton onClick={handleClose}>
// 						<CloseIcon />
// 					</StyledCrossIconButton>
// 				</div>
// 				<Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
// 					<StyledTabs
// 						value={tabValue}
// 						onChange={handleTabChange}
// 						aria-label="order tabs"
// 						style={{ fontFamily: 'Poppins' }}
// 					>
// 						<StyledTab label="Summary" style={{ fontFamily: 'Poppins' }} />
// 						<StyledTab label="Item" style={{ fontFamily: 'Poppins' }} />
// 						<StyledTab label="Customer" style={{ fontFamily: 'Poppins' }} />
// 					</StyledTabs>
// 				</Box>
// 				{tabValue === 0 && selectedOrder && (
// 					<Card sx={{ borderRadius: '8px', mb: 2 }}>
// 						<CardContent>
// 							<Table>
// 								<TableBody>
// 									<TableRow>
// 										<TableCell>
// 											<strong style={{ fontFamily: 'Poppins' }}>
// 												Order ID:
// 											</strong>
// 										</TableCell>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											{selectedOrder?.orderId}
// 										</TableCell>
// 									</TableRow>
// 									<TableRow>
// 										<TableCell>
// 											<strong style={{ fontFamily: 'Poppins' }}>
// 												Order Status:
// 											</strong>
// 										</TableCell>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											{selectedOrder?.orderStatus}
// 										</TableCell>
// 									</TableRow>
// 									<TableRow>
// 										<TableCell>
// 											<strong style={{ fontFamily: 'Poppins' }}>
// 												phone:
// 											</strong>
// 										</TableCell>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											{selectedOrder?.shippingAddress?.phone}
// 										</TableCell>
// 									</TableRow>
// 									<TableRow>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											<strong style={{ fontFamily: 'Poppins' }}>
// 												Payment Status:
// 											</strong>
// 										</TableCell>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											{selectedOrder?.paymentStatus}
// 										</TableCell>
// 									</TableRow>
// 									<TableRow>
// 										<TableCell>
// 											<strong style={{ fontFamily: 'Poppins' }}>
// 												Shipping Method:
// 											</strong>
// 										</TableCell>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											{selectedOrder?.shiprocketOrderId}
// 										</TableCell>
// 									</TableRow>
// 									<TableRow>
// 										<TableCell>
// 											<strong style={{ fontFamily: 'Poppins' }}>
// 												Total Price:
// 											</strong>
// 										</TableCell>
// 										<TableCell style={{ fontFamily: 'Poppins' }}>
// 											{selectedOrder?.totalAmount}
// 										</TableCell>
// 									</TableRow>
// 								</TableBody>
// 							</Table>
// 						</CardContent>
// 					</Card>
// 				)}
// 				{tabValue === 1 && selectedOrder && (
// 					<Card sx={{ borderRadius: '8px', mb: 2 }}>
// 						<CardContent>
// 							<div>
// 								<Table>
// 									<TableHead>
// 										<TableRow>
// 											<TableCell>
// 												<strong style={{ fontFamily: 'Poppins' }}>
// 													Ordered Item:
// 												</strong>
// 											</TableCell>
// 											<TableCell>
// 												<strong style={{ fontFamily: 'Poppins' }}>
// 													Quantity:
// 												</strong>
// 											</TableCell>
// 											<TableCell>
// 												<strong style={{ fontFamily: 'Poppins' }}>
// 													Product:
// 												</strong>
// 											</TableCell>
// 											<TableCell>
// 												<strong style={{ fontFamily: 'Poppins' }}>
// 													Category:
// 												</strong>
// 											</TableCell>
// 											<TableCell>
// 												<strong style={{ fontFamily: 'Poppins' }}>
// 													Price:
// 												</strong>
// 											</TableCell>
// 											<TableCell>
// 												<strong style={{ fontFamily: 'Poppins' }}>
// 													Total:
// 												</strong>
// 											</TableCell>
// 										</TableRow>
// 									</TableHead>
// 									<TableBody>
// 										{selectedOrder?.items?.map((item: OrderItem) => (
// 											<TableRow
// 												key={item?.productId}
// 												style={{ fontFamily: 'Poppins' }}
// 											>
// 												<TableCell>{item?.name}</TableCell>
// 												<TableCell>{item?.quantity}</TableCell>
// 												<TableCell>{item?.productId}</TableCell>
// 												<TableCell>{item?.weight}</TableCell>
// 												<TableCell>{item?.price}</TableCell>
// 												<TableCell>{item?.subtotal}</TableCell>
// 											</TableRow>
// 										))}
// 									</TableBody>
// 								</Table>
// 							</div>
// 						</CardContent>
// 					</Card>
// 				)}
// 				{tabValue === 2 && selectedOrder && (
// 					<Card sx={{ borderRadius: '8px', mb: 2 }}>
// 						<CardContent>
// 							<Table>
// 								<TableBody>
// 									<TableRow>
// 										<TableCell>
// 											<strong>Customer Name:</strong>
// 										</TableCell>
// 										<TableCell>{selectedOrder?.shippingAddress?.name}</TableCell>
// 									</TableRow>

// 									<TableRow>
// 										<TableCell>
// 											<strong>Phone:</strong>
// 										</TableCell>
// 										<TableCell>{selectedOrder?.shippingAddress?.phone}</TableCell>
// 									</TableRow>
// 									<TableRow>
// 										<TableCell>
// 											<strong>Shipping Address:</strong>
// 										</TableCell>
// 										<TableCell>
// 											{selectedOrder?.shippingAddress?.address},{' '}
// 											{selectedOrder?.shippingAddress?.city},{' '}
// 											{selectedOrder?.shippingAddress?.state},{' '}
// 											{selectedOrder?.shippingAddress?.postalCode},{' '}
// 											{selectedOrder?.shippingAddress?.country}
// 										</TableCell>
// 									</TableRow>
// 								</TableBody>
// 							</Table>
// 						</CardContent>
// 					</Card>
// 				)}
// 				<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
// 					<Button
// 						variant="outlined"
// 						// color="error"
// 						// sx={{ '&:hover': { color: '#fff' } }}
// 						onClick={handleClose}
// 					>
// 						Close
// 					</Button>
// 				</Box>
// 			</Box>
// 		</Modal>
// 	);
// };

// export default ReuseableTap;

import {
	Button,
	Card,
	CardContent,
	Modal,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import {
	StyledCrossIconButton,
	StyledTab,
	StyledTabs,
} from '../../components/component/ThemeComponent';

interface OrderItem {
	productId: string;
	quantity: number;
	price: number;
	subtotal: number;
	weight: number;
	name: string;
	category: string;
}

interface ShippingAddress {
	name: string | object;
	phone: string | object;
	address: string | object;
	city: string | object;
	state: string | object;
	country: string | object;
	postalCode: string | object;
	email: string | object;
}

interface Order {
	_id: string;
	orderId: string;
	orderStatus: string;
	paymentStatus: string;
	razorpayOrderId: string;
	shiprocketOrderId: string;
	shiprocketReferenceId: string;
	totalAmount: number;
	totalWeight: number;
	createdAt: string;
	updatedAt: string;
	userId: string;
	cancelReason: string | null;
	items: OrderItem[];
	shippingAddress: ShippingAddress;
}

const ReuseableTap = ({
	selectedOrder,
	handleClose,
	open,
}: {
	selectedOrder: Order;
	handleClose: () => void;
	open: boolean;
}) => {
	const [tabValue, setTabValue] = useState<number>(0);

	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setTabValue(newValue);
	};

	// helper to safely convert values to string
	const safeText = (val: any) => {
		if (!val) return '';
		if (typeof val === 'object') return JSON.stringify(val);
		return String(val);
	};

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: { xs: 300, sm: 400, md: '80%' },
					bgcolor: 'background.paper',
					border: '0px',
					boxShadow: 24,
					p: 4,
					borderRadius: '8px',
				}}
			>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Typography
						id="modal-modal-title"
						variant="h6"
						component="h2"
						style={{ fontFamily: 'Poppins' }}
					>
						Order Details
					</Typography>
					<StyledCrossIconButton onClick={handleClose}>
						<CloseIcon />
					</StyledCrossIconButton>
				</div>

				<Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
					<StyledTabs
						value={tabValue}
						onChange={handleTabChange}
						aria-label="order tabs"
						style={{ fontFamily: 'Poppins' }}
					>
						<StyledTab label="Summary" style={{ fontFamily: 'Poppins' }} />
						<StyledTab label="Item" style={{ fontFamily: 'Poppins' }} />
						<StyledTab label="Customer" style={{ fontFamily: 'Poppins' }} />
					</StyledTabs>
				</Box>

				{/* Summary Tab */}
				{tabValue === 0 && selectedOrder && (
					<Card sx={{ borderRadius: '8px', mb: 2 }}>
						<CardContent>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell>
											<strong>Order ID:</strong>
										</TableCell>
										<TableCell>{safeText(selectedOrder?.orderId)}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Order Status:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.orderStatus)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Phone:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.shippingAddress?.phone)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Payment Status:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.paymentStatus)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Shipping Method:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.shiprocketOrderId)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Total Price:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.totalAmount)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</CardContent>
					</Card>
				)}

				{/* Items Tab */}
				{tabValue === 1 && selectedOrder && (
					<Card sx={{ borderRadius: '8px', mb: 2 }}>
						<CardContent>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell>
											<strong>Ordered Item:</strong>
										</TableCell>
										<TableCell>
											<strong>Quantity:</strong>
										</TableCell>
										<TableCell>
											<strong>Product:</strong>
										</TableCell>
										<TableCell>
											<strong>Category:</strong>
										</TableCell>
										<TableCell>
											<strong>Price:</strong>
										</TableCell>
										<TableCell>
											<strong>Total:</strong>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{selectedOrder?.items?.map((item: OrderItem) => (
										<TableRow key={item?.productId}>
											<TableCell>{safeText(item?.name)}</TableCell>
											<TableCell>{safeText(item?.quantity)}</TableCell>
											<TableCell>{safeText(item?.name)}</TableCell>
											<TableCell>{safeText(item?.weight)}</TableCell>
											<TableCell>{safeText(item?.price)}</TableCell>
											<TableCell>{safeText(item?.subtotal)}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</CardContent>
					</Card>
				)}

				{/* Customer Tab */}
				{tabValue === 2 && selectedOrder && (
					<Card sx={{ borderRadius: '8px', mb: 2 }}>
						<CardContent>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell>
											<strong>Customer Name:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.shippingAddress?.name)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Phone:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.shippingAddress?.phone)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell>
											<strong>Shipping Address:</strong>
										</TableCell>
										<TableCell>
											{safeText(selectedOrder?.shippingAddress?.address)},
											{safeText(selectedOrder?.shippingAddress?.city)},
											{safeText(selectedOrder?.shippingAddress?.state)},
											{safeText(selectedOrder?.shippingAddress?.postalCode)},
											{safeText(selectedOrder?.shippingAddress?.country)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</CardContent>
					</Card>
				)}

				<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button variant="outlined" onClick={handleClose}>
						Close
					</Button>
				</Box>
			</Box>
		</Modal>
	);
};

export default ReuseableTap;
